exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper .el-form-item .el-form-item__label{color:#fff}", ""]);

// exports
